import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AgentChatStore } from 'src/app/services/agent-chat/agent-chat-store.service';
import { AgentChatPanelComponent } from '../panel/agent-chat-panel.component';
import { MatIconModule } from '@angular/material/icon';

/**
 * The support chat's launcher, bottom-right (GOO-457), with the unread badge and the panel above
 * it. On a narrow screen the panel takes the whole viewport.
 */
@Component({
  selector: 'app-agent-chat-launcher',
  standalone: true,
  imports: [TranslatePipe, AgentChatPanelComponent, MatIconModule],
  templateUrl: './agent-chat-launcher.component.html',
})
export class AgentChatLauncherComponent implements OnInit {
  readonly store = inject(AgentChatStore);

  ngOnInit() {
    this.store.refreshStatus();
  }
}
